import React from "react";
import { Box, Stack, Typography, Paper, Avatar } from "@mui/material";
import Markdown from "markdown-to-jsx";
import SparklesIcon from "@mui/icons-material/AutoAwesome"; // Representing sparkles

const AIMessage = ({ content }) => {
  return (
    <Stack direction="row" alignItems="flex-start" spacing={2} mb={3}>
      {/* AI Avatar */}
      <Avatar
        sx={{
          bgcolor: "grey.900",
          width: 36,
          height: 36,
          fontSize: 14,
          fontWeight: 600,
        }}
      >
        <SparklesIcon />
      </Avatar>

      {/* Message Bubble */}
      <Box>
        <Typography
          variant="subtitle2"
          sx={{ fontWeight: "bold", color: "text.primary", mb: 0.5 }}
        >
          Flexi AI
        </Typography>

        <Paper
          elevation={1}
          sx={{
            p: 2,
            borderRadius: 3,
            bgcolor: "rgba(245, 245, 245, 0.7)",
            backdropFilter: "blur(4px)",
            boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
            maxWidth: "75%",
            fontSize: 15,
            lineHeight: 1.6,
          }}
        >
          {typeof content === "string" ? (
            <Markdown>{content}</Markdown>
          ) : (
            content
          )}
        </Paper>
      </Box>
    </Stack>
  );
};

export default AIMessage;
